// Bloque 4 (feb-2026) — Botón de descarga del ACUSE DE DESEMBOLSO por integrante.
//
// Solo aplica a créditos grupales YA desembolsados (`estatus_desembolso === "desembolsado"`).
// Se usa en 2 lugares:
//   - Mesa de Control (pantalla de desembolso) — filas de "Desembolsos realizados".
//   - Cartera / ficha del crédito — fila por integrante en la tabla del grupo.
//
// Reutiliza el patrón blob + Bearer de HojasIntegrantesButtons.jsx.
import { useState } from "react";
import { FileText, Loader2 } from "lucide-react";
import { TooltipButton } from "@/components/common/Tooltips";
import { api } from "@/lib/api";
import { toast } from "sonner";

async function descargarPdf(path, nombreArchivo) {
  const res = await api.get(path, { responseType: "blob" });
  const blob = new Blob([res.data], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = nombreArchivo;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 400);
}

/** Botón por INTEGRANTE. `variant="compact"` muestra solo icono (para tablas densas). */
export function AcuseDesembolsoIntegranteButton({ credito, integrante, variant = "text" }) {
  const [busy, setBusy] = useState(false);
  if (!credito?.id || !integrante?.cliente_id) return null;
  const yaDesembolsado = String(credito?.estatus_desembolso || "").toLowerCase() === "desembolsado";
  if (!yaDesembolsado) return null;
  const nombreSlug = String(integrante.cliente || integrante.cliente_id)
    .replace(/\s+/g, "_")
    .slice(0, 40);
  const onClick = async () => {
    setBusy(true);
    try {
      await descargarPdf(
        `/creditos/${credito.id}/acuse-desembolso-integrante/${integrante.cliente_id}`,
        `Acuse_${credito.numero_credito || credito.id}_${nombreSlug}.pdf`
      );
      toast.success(`Acuse del integrante ${integrante.cliente || nombreSlug} descargado`);
    } catch (e) {
      toast.error(
        e?.response?.data?.detail || "No se pudo generar el acuse del integrante"
      );
    } finally {
      setBusy(false);
    }
  };
  const testid = `acuse-integrante-${integrante.cliente_id}`;
  if (variant === "compact") {
    return (
      <TooltipButton
        tooltip={`Descargar el acuse de desembolso de ${integrante.cliente || "este integrante"} (PDF con desglose Art. 11 LTOSF por integrante)`}
        size="sm" variant="outline" className="h-7 px-2"
        onClick={onClick} disabled={busy} data-testid={testid}
      >
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" />
              : <FileText className="h-3.5 w-3.5" />}
      </TooltipButton>
    );
  }
  return (
    <TooltipButton
      tooltip="Descargar el acuse de desembolso del integrante (PDF con desglose Art. 11 LTOSF por porción individual)"
      size="sm" variant="outline" className="h-7"
      onClick={onClick} disabled={busy} data-testid={testid}
    >
      {busy ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" />
            : <FileText className="mr-1.5 h-3.5 w-3.5" />}
      Acuse
    </TooltipButton>
  );
}
